export const ITEMS = {
  LIST: '/new_items',
  ADD: '/new_items/add',
  ID: '/new_items/:id',
  IMPORT: 'items/import_csv_items_list',
};
export const PROMOTIONS = {
  LIST: '/promotion_advances',
  ADD: '/promotion_advances/add',
  ID: '/promotion_advances/:id',
};

export const PRODUCT_OPTION = {
  LIST: '/product-option',
  ADD: '/product-option/add',
  ID: '/product-option/:id',
};

export const CATEGORY = {
  LIST: 'new_category',
};

export const TAG = {
  LIST: '/tags',
};

export const CUSTOMER = {
  LIST: '/new_customers',
};
export const TIME_ATTENDANCE = {
  LIST: '/time_attendance',
};

export const SETTINGS = {
  ROOT: '/new_config',
  V2: '/settings-v2',
};
